import { DETAILS } from '@web-platform/shared-banana-constants/src/routes';
import { matchHashPath } from '@web-platform/shared-banana-utils-frontend/src/helpers/removeHashSymbol';

import type { LocationChangedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

type Location = LocationChangedAction['payload']['location'];

const isBookingPanel = (location: Location): boolean => !!matchHashPath(location.hash, DETAILS);

export const getExitingBookingPanelItineraryId = (
  location: Location,
  prevLocation: Location | undefined,
): string | undefined => {
  if (!prevLocation || !isBookingPanel(prevLocation) || isBookingPanel(location)) return undefined;

  const match = matchHashPath(prevLocation.hash, DETAILS);
  const encoded = match?.params?.itineraryId;
  return encoded ? decodeURIComponent(encoded) : undefined;
};
